(() => {
  const DRAG_THRESHOLD = 10;

  const initCarousel = (root) => {
    if (!root || root.dataset.hhReady === 'true') return;
    root.dataset.hhReady = 'true';

    const track = root.querySelector('[data-hh-track]');
    const prev = root.querySelector('[data-hh-prev]');
    const next = root.querySelector('[data-hh-next]');
    const progress = root.querySelector('[data-hh-progress]');
    if (!track) return;

    const getStep = () => {
      const slide = track.querySelector('.hh-carousel__slide, .hh-lookbook__slide');
      if (!slide) return Math.max(280, track.clientWidth * 0.75);
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return Math.round(slide.getBoundingClientRect().width + gap);
    };

    const maxScrollLeft = () => Math.max(0, track.scrollWidth - track.clientWidth);

    const updateUI = () => {
      const maxScroll = maxScrollLeft();
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft >= maxScroll - 4;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd || maxScroll <= 0;

      if (progress) {
        const ratio = maxScroll <= 0 ? 1 : track.scrollLeft / maxScroll;
        const width = Math.max(18, Math.min(100, ratio * 100 + 18));
        progress.style.width = `${width}%`;
      }
    };

    const scrollByDir = (dir) => {
      const step = getStep();
      const target = Math.max(0, Math.min(maxScrollLeft(), track.scrollLeft + dir * step));
      track.scrollTo({ left: target, behavior: 'smooth' });
      window.setTimeout(updateUI, 380);
    };

    prev?.addEventListener('click', (e) => {
      e.preventDefault();
      scrollByDir(-1);
    });
    next?.addEventListener('click', (e) => {
      e.preventDefault();
      scrollByDir(1);
    });
    track.addEventListener('scroll', updateUI, { passive: true });
    window.addEventListener('resize', updateUI);

    /* Mouse-drag only. Touch / trackpad keep native vertical + horizontal scroll. */
    let isDown = false;
    let didDrag = false;
    let axis = null;
    let startX = 0;
    let startY = 0;
    let startScroll = 0;
    let pointerId = null;

    const resetDrag = () => {
      isDown = false;
      axis = null;
      pointerId = null;
      track.classList.remove('is-dragging');
      updateUI();
    };

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, input, label, select, textarea')) return;

      isDown = true;
      didDrag = false;
      axis = null;
      startX = e.clientX;
      startY = e.clientY;
      startScroll = track.scrollLeft;
      pointerId = e.pointerId;
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDown || pointerId !== e.pointerId) return;

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (!axis) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') {
          resetDrag();
          return;
        }
        didDrag = true;
        track.classList.add('is-dragging');
        try {
          track.setPointerCapture(e.pointerId);
        } catch (err) {
          /* ignore */
        }
      }

      if (axis === 'x') {
        track.scrollLeft = startScroll - dx;
      }
    });

    track.addEventListener('pointerup', resetDrag);
    track.addEventListener('pointercancel', resetDrag);

    track.addEventListener(
      'click',
      (e) => {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      },
      true
    );

    track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', updateUI, { once: true });
    });

    requestAnimationFrame(updateUI);
  };

  const boot = () => {
    document.querySelectorAll('[data-hh-carousel]').forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-hh-carousel]') || event.target;
    if (root?.matches?.('[data-hh-carousel]')) {
      root.dataset.hhReady = 'false';
      initCarousel(root);
    }
  });
})();
